// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"bd6826ac","373":"4f8ea70c","787":"d5fa4d18","822":"94885265","830":"10b63302","847":"30f4d627","994":"a469d514"}[chunkId] + ".chunk.js";
};